import { IDataProducto } from "@/shared/interfaces";
import { PaginationState } from "@tanstack/react-table"; // Para Material React Table
import { create } from "zustand";

interface ProductoState {
  listaProducto: IDataProducto[];
  paginatedProductoData: IDataProducto[];
  pagination: PaginationState;
  //*aciones de store
  setListaProducto: (productos: IDataProducto[]) => void
  setPagination: (pagination: PaginationState | ((prev: PaginationState) => PaginationState)) => void;
  handleCargarListaProductos:(producto: IDataProducto[]) => void;
  clearSelectedItems:()=>void;
  //updatePaginationData: () => void;
}
export const useSinSeriesProducto = create<ProductoState>((set) => ({
  //*estado Inicial
  listaProducto: [],
  paginatedProductoData: [],
  pagination: { pageIndex: 0, pageSize: 5 },
  //Implementacion de acciones

  clearSelectedItems(){
    set(()=>{
      return{
        listaProducto:[],
        paginatedProductoData:[],
        pagination:{pageIndex:0, pageSize:5},
        
       
      }
    })
  },

  setListaProducto: (productos) => {
   set({
    listaProducto: productos,
    paginatedProductoData: productos.slice(0,10),
    pagination:{pageIndex: 0, pageSize:10}
   })
  },
  setPagination:(pagination)=>{
   set((state)=>{
    const newPagination = typeof pagination === "function"
    ? pagination(state.pagination) : pagination;
    return{
      pagination:newPagination,
      paginatedProductoData: state.listaProducto.slice(
        newPagination.pageIndex * newPagination.pageSize,
        (newPagination.pageIndex + 1) * newPagination.pageSize
      )
    }
   })
  },
/*   updatePaginationData:()=>{
   const{listaProducto, pagination}=get();
   set({
    paginatedProductoData: listaProducto.slice(
      pagination.pageIndex * pagination.pageSize,
      (pagination.pageIndex + 1) * pagination.pageSize
    )
   })
  }, */
  handleCargarListaProductos:(producto)=>{
    set((state)=>{
      return{
        listaProducto:producto,
        paginatedProductoData: producto.slice(
          state.pagination.pageIndex * state.pagination.pageSize,
          (state.pagination.pageIndex + 1) * state.pagination.pageSize
        )
      }
    })
  }
}))